import Committees from './Committees';

export default Committees;
